'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dSettings$0024$002dVersion$0024$0024anon$00242 from "./app.data.-General-Practice-User-Settings$-Version$$anon$2.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_data_GeneralPracticeUserSettings$Version$__V0__Lapp_data_GeneralPracticeUserSettings$Version() {
  $m_Lapp_data_GeneralPracticeUserSettings$Version$();
  return $t_Lapp_data_GeneralPracticeUserSettings$Version$__V0;
}
export { $s_Lapp_data_GeneralPracticeUserSettings$Version$__V0__Lapp_data_GeneralPracticeUserSettings$Version as $s_Lapp_data_GeneralPracticeUserSettings$Version$__V0__Lapp_data_GeneralPracticeUserSettings$Version };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserSettings$Version$() {
  $n_Lapp_data_GeneralPracticeUserSettings$Version$ = this;
  $t_Lapp_data_GeneralPracticeUserSettings$Version$__V0 = new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dSettings$0024$002dVersion$0024$0024anon$00242.$c_Lapp_data_GeneralPracticeUserSettings$Version$$anon$2("V0", 0);
  $s_Lapp_data_GeneralPracticeUserSettings$Version$__V0__Lapp_data_GeneralPracticeUserSettings$Version();
}
export { $c_Lapp_data_GeneralPracticeUserSettings$Version$ as $c_Lapp_data_GeneralPracticeUserSettings$Version$ };
$c_Lapp_data_GeneralPracticeUserSettings$Version$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserSettings$Version$.prototype.constructor = $c_Lapp_data_GeneralPracticeUserSettings$Version$;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserSettings$Version$() {
}
export { $h_Lapp_data_GeneralPracticeUserSettings$Version$ as $h_Lapp_data_GeneralPracticeUserSettings$Version$ };
$h_Lapp_data_GeneralPracticeUserSettings$Version$.prototype = $c_Lapp_data_GeneralPracticeUserSettings$Version$.prototype;
$c_Lapp_data_GeneralPracticeUserSettings$Version$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_data_GeneralPracticeUserSettings$Version$$anon$2__f__$ordinal$1;
});
var $d_Lapp_data_GeneralPracticeUserSettings$Version$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserSettings$Version$, "app.data.GeneralPracticeUserSettings$Version$", ({
  Lapp_data_GeneralPracticeUserSettings$Version$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_data_GeneralPracticeUserSettings$Version$ as $d_Lapp_data_GeneralPracticeUserSettings$Version$ };
var $n_Lapp_data_GeneralPracticeUserSettings$Version$;
function $m_Lapp_data_GeneralPracticeUserSettings$Version$() {
  if ((!$n_Lapp_data_GeneralPracticeUserSettings$Version$)) {
    $n_Lapp_data_GeneralPracticeUserSettings$Version$ = new $c_Lapp_data_GeneralPracticeUserSettings$Version$();
  }
  return $n_Lapp_data_GeneralPracticeUserSettings$Version$;
}
export { $m_Lapp_data_GeneralPracticeUserSettings$Version$ as $m_Lapp_data_GeneralPracticeUserSettings$Version$ };
var $t_Lapp_data_GeneralPracticeUserSettings$Version$__V0 = null;
function $u_Lapp_data_GeneralPracticeUserSettings$Version$__V0(x) {
  $t_Lapp_data_GeneralPracticeUserSettings$Version$__V0 = x;
}
export { $t_Lapp_data_GeneralPracticeUserSettings$Version$__V0 as $t_Lapp_data_GeneralPracticeUserSettings$Version$__V0, $u_Lapp_data_GeneralPracticeUserSettings$Version$__V0 as $u_Lapp_data_GeneralPracticeUserSettings$Version$__V0 };
//# sourceMappingURL=app.data.-General-Practice-User-Settings$-Version$.js.map
